import { render, staticRenderFns } from "./HomeBottomFixedNav.vue?vue&type=template&id=24c527b5&scoped=true&"
import script from "./HomeBottomFixedNav.vue?vue&type=script&lang=js&"
export * from "./HomeBottomFixedNav.vue?vue&type=script&lang=js&"
import style0 from "./HomeBottomFixedNav.vue?vue&type=style&index=0&id=24c527b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c527b5",
  null
  
)

export default component.exports